import { useQuery } from "@tanstack/react-query";
import { TestRow } from "../api/test.type";
import { getTests } from "../api/tests.api";
import { useUserDetails } from "./useUserDetails";

function useLoadTests(userId?: string) {
  const { userDetails } = useUserDetails();

  const {
    data: tests = [],
    isLoading,
    error,
  } = useQuery<TestRow[]>({
    queryKey: ["tests", userId || userDetails?.id],
    queryFn: () => getTests(userId || userDetails?.id),
  });

  return { tests, isLoading, error };
}

export default useLoadTests;
